import React from 'react'
import styled from 'styled-components'

const IPContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const IPAddress = styled.span`
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  color: #333;
  flex: 1;
  text-align: left;
`

interface IPTextProps {
  ip: string
  mutate?: () => void
}

const IPText: React.FC<IPTextProps> = ({ ip, mutate }) => {
  return (
    <IPContainer>
      <IPAddress>{ip}</IPAddress>
    </IPContainer>
  )
}

export default IPText
